// extracted by mini-css-extract-plugin
export var grid = "_22-0";
export var span1 = "_22-2";
export var span10 = "_22-b";
export var span10L = "_22-z";
export var span10M = "_22-n";
export var span10Xl = "_22-1b";
export var span11 = "_22-c";
export var span11L = "_22-10";
export var span11M = "_22-o";
export var span11Xl = "_22-1c";
export var span12 = "_22-d";
export var span12L = "_22-11";
export var span12M = "_22-p";
export var span12Xl = "_22-1d";
export var span1L = "_22-q";
export var span1M = "_22-e";
export var span1Xl = "_22-12";
export var span2 = "_22-3";
export var span2L = "_22-r";
export var span2M = "_22-f";
export var span2Xl = "_22-13";
export var span3 = "_22-4";
export var span3L = "_22-s";
export var span3M = "_22-g";
export var span3Xl = "_22-14";
export var span4 = "_22-5";
export var span4L = "_22-t";
export var span4M = "_22-h";
export var span4Xl = "_22-15";
export var span5 = "_22-6";
export var span5L = "_22-u";
export var span5M = "_22-i";
export var span5Xl = "_22-16";
export var span6 = "_22-7";
export var span6L = "_22-v";
export var span6M = "_22-j";
export var span6Xl = "_22-17";
export var span7 = "_22-8";
export var span7L = "_22-w";
export var span7M = "_22-k";
export var span7Xl = "_22-18";
export var span8 = "_22-9";
export var span8L = "_22-x";
export var span8M = "_22-l";
export var span8Xl = "_22-19";
export var span9 = "_22-a";
export var span9L = "_22-y";
export var span9M = "_22-m";
export var span9Xl = "_22-1a";
export var stretch = "_22-1";